<template>
  <section class="hero is-alt is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-4 is-offset-4">
            <div class="field">
              <h1
                class="title is-1"
                style="margin-bottom: 3rem; text-align: center;"
              >
                my services
              </h1>
            </div>
            <div class="field">
              <p class="control has-icons-left">
                <input
                  class="input is-large"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button
                  class="button is-success is-fullwidth is-large"
                  @click="login"
                >
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import auth from "../auth";
import { log } from "util";
export default {
  props: {
    onLogin: {
      type: Function,
      default: function(user) {
        log("User " + user + " login");
      },
    },
  },
  data() {
    return {
      password: null,
    };
  },
  methods: {
    login: function() {
      const self = this;
      auth.login("root", this.password, function(status) {
        if (status) {
          self.onLogin("Viewer");
          self.$router.replace(self.$route.query.redirect || "/");
        }
      });
    },
  },
};
</script>

<style scoped></style>
